import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

const fmtPeriodo = (p) => {
  if (!p) return '';
  if (typeof p === 'string') return p.substring(0, 10);
  return `${p.getFullYear()}-${String(p.getMonth() + 1).padStart(2, '0')}-${String(p.getDate()).padStart(2, '0')}`;
};

export const getResumenGeneral = (barrioId, administracionId, periodo) =>
  axios.get(`${HOST_API}api/dashboard/resumenGastos`, {
    params: { barrioId, administracionId, periodo: fmtPeriodo(periodo) },
  });

export const getGastosPorRubro = (barrioId, administracionId, periodo) =>
  axios.get(`${HOST_API}api/dashboard/gastosPorRubro`, {
    params: { barrioId, administracionId, periodo: fmtPeriodo(periodo) },
  });

export const getGastosPorProveedor = (barrioId, administracionId, periodo) =>
  axios.get(`${HOST_API}api/dashboard/gastosPorProveedor`, {
    params: { barrioId, administracionId, periodo: fmtPeriodo(periodo) },
  });

export const getDeudoresExpensas = (barrioId, administracionId, periodo) =>
  axios.get(`${HOST_API}api/reporte/deudoresExpensas`, {
    params: { barrioId, administracionId, periodo },
  });

export const getResumenExpensas = (barrioId, administracionId, periodo) =>
  axios.get(`${HOST_API}api/reporte/resumenExpensas`, {
    params: { barrioId, administracionId, periodo },
  });

export const getDetalleGastos = (barrioId, administracionId, periodo) =>
  axios.get(`${HOST_API}api/gastoBarrio/getByBarrio`, {
    params: { barrioId, administracionId, periodo },
  });

export const getExpensasPDF = (barrioId, administracionId, periodo) =>
  axios.post(`${HOST_API}api/expensaBarrio/getByBarrio`, {
    barrioId,
    administracionId,
    periodo,
  });

export const getPersonasBarrio = (barrioId, administracionId) =>
  axios.get(`${HOST_API}api/personas/GetPersonas`, {
    params: { administracionId, personaId: 0, barrioId },
  });

export const enviarMailConAdjunto = (destinatarios, asunto, htmlMail, adjuntoBase64, adjuntoNombre) =>
  axios.post(`${HOST_API}api/mail/enviar`, {
    destinatarios,
    asunto,
    htmlMail,
    adjuntoBase64,
    adjuntoNombre,
  });